import _ from 'lodash';
import { textColorPicker, stringInputSpec } from './editing-configs';
import getValidColor from './get-valid-color';

const customTextColorPicker = (baseName, label) => {
  return {
    ...textColorPicker,
    fieldName: `${baseName}.textColor`,
    fieldLabel: label || 'Text color',
    items: [
      ...textColorPicker.items,
      {
        value: 'HEXCOLOR',
        label: 'Hexcolor',
      },
    ],
  };
};

const getTextColor = (options) => {
  if (options?.textColor === 'HEXCOLOR') {
    return { textColor: options.hexColor, isHex: true };
  }
  return { textColor: getValidColor(options?.textColor) || '', isHex: false };
};

getTextColor.getEditingConfig = (
  componentDocument,
  fieldName,
  label,
  hexColorLabelOverride,
  nestedPath
) => {
  const baseName = fieldName || 'textColorOptions';
  const hexColorLabel = hexColorLabelOverride || 'Hex color override';

  const optionalSelect =
    _.get(
      componentDocument,
      // looks over 'nestedPath' to support nested path e.g: under a repeatable panel component
      `props.${nestedPath || baseName}.textColor`,
      ''
    ) === 'HEXCOLOR'
      ? [stringInputSpec(`${baseName}.hexColor`, hexColorLabel)]
      : [];
  return [customTextColorPicker(baseName, label), ...optionalSelect];
};

export default getTextColor;
